//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClickOutside from '@/directives/ClickOutside';
import Emitter from '@/mixins/emitter';

export default {
  name: 'DpDropdown',
  directives: { ClickOutside },
  mixins: [Emitter],
  props: {
    visible: { type: Boolean, default: false },
    anchor: { type: HTMLElement, default: null },
    width: { type: Number, default: null },
    minWidth: { type: Number, default: 50 },
    leftAligned: { type: Boolean, default: false },
    topOffset: { type: Number, default: -2 },
    leftOffset: { type: Number, default: 0 },
    rightOffset: { type: Number, default: 10 },
    inheritWidth: { type: Boolean, default: false },
    arrowPosition: { type: String, default: 'top' },
  },
  data() {
    return {
      isAbove: false,
      internalVisible: false,
      appRoot: null,
    };
  },
  computed: {
    parentElement() {
      const parent = this.anchor || this.$el.parentNode;
      return parent;
    },
    styleArrowPosition() {
      let pos = this.isAbove ? 'bottom' : 'top';
      const stripped = this.arrowPosition.replace('top', '').replace('bottom', '');
      pos += stripped;
      return pos;
    },
  },
  watch: {
    visible() {
      this.internalVisible = this.visible;
      this.updatePosition().then(() => {
        if (this.visible) {
          window.addEventListener('scroll', this.updatePosition, true);
        } else {
          window.removeEventListener('scroll', this.updatePosition, true);
        }
      });
    },
  },
  mounted() {
    // Handle the event from dropdown-items
    this.$on('handleClick', this.close);

    this.appRoot = document.querySelector('#app-root') || document.querySelector('#docs-root');
    // Don't mount at top level for testing
    if (this.appRoot) {
      this.appRoot.appendChild(this.$refs.dropdown);
    }

    this.$nextTick(() => {
      this.updatePosition();
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateDropdownPosition, true);
    if (this.appRoot) {
      this.appRoot.removeChild(this.$refs.dropdown);
    }
  },
  methods: {
    updatePosition() {
      return new Promise((resolve) => {
        const $parent = this.anchor || this.$el.parentNode;
        const $el = this.$refs.dropdown;
        if (!$el || !$parent) return;

        const heightOffset = this.topOffset;
        const heightCheckSize = $el.clientHeight;
        const containerPos = $parent.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const yPos = containerPos.top + containerPos.height;

        // Check the direction
        const canFitBelow = yPos + heightCheckSize < windowHeight;
        const canFitAbove = yPos - heightCheckSize > 0;
        if (!canFitBelow && canFitAbove) {
          // Dropdown above
          $el.style.bottom = `${windowHeight - containerPos.top - heightOffset}px`;
          $el.style.top = 'auto';
          this.isAbove = true;
        } else {
          // Dropdown below
          $el.style.top = `${yPos - heightOffset}px`;
          $el.style.bottom = 'auto';
          this.isAbove = false;
        }

        const { inheritWidth, minWidth, width } = this;
        let targetWidth = $el.clientWidth;
        if (inheritWidth) {
          targetWidth = $parent.clientWidth;
        } else if (width) {
          targetWidth = width;
        }

        targetWidth = Math.max(targetWidth, minWidth);
        $el.style.width = `${targetWidth}px`;

        const { arrowPosition } = this;
        let left;
        if (arrowPosition.includes('left')) {
          left = containerPos.left + this.leftOffset;
        } else if (arrowPosition.includes('right')) {
          const rightPadding = $parent.clientWidth;
          left = containerPos.left - targetWidth + rightPadding + this.rightOffset;
        } else {
          const widthOffset = (containerPos.width - targetWidth) / 2;
          left = containerPos.left + widthOffset + this.leftOffset;
        }
        $el.style.left = `${left}px`;

        setTimeout(() => {
          resolve();
        }, 10);
      });
    },
    open() {
      this.$emit('update:visible', true);
      this.$emit('open');
    },
    close(e) {
      // If the user is clicking the original toggle, do not update the visible property
      if (this.parentElement.contains(e.target)) {
        this.$emit('close');
        return;
      }

      this.$emit('update:visible', false);
      this.$emit('close');
    },
  },
};
